import { useAuthActionsContext } from '../context/AuthContext';

export const useAuthActions = () => useAuthActionsContext();
export const useLogin = () => useAuthActionsContext().login;
export const useLogout = () => useAuthActionsContext().logout;
export const useIncarnate = () => useAuthActionsContext().incarnate;
export const useRegisterAndLogin = () => useAuthActionsContext().registerAndLogin;
export const useGuestRegister = () => useAuthActionsContext().guestRegister;
export const useHashLogin = () => useAuthActionsContext().hashLogin;
export const useWakeUp = () => useAuthActionsContext().wakeUp;
export const useLoginGoogle = () => useAuthActionsContext().loginGoogle;
export const useRequestNewPassword = () => useAuthActionsContext().requestNewPassword;
export const useRestorePassword = () => useAuthActionsContext().restorePassword;
